import React from 'react';
import { Button } from '@heroui/react';

interface ErrorDisplayProps {
  error: string | null;
  onClose: () => void;
  className?: string;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error, onClose, className = '' }) => {
  if (!error) return null;

  return (
    <div className={`bg-red-600 rounded-3xl shadow-xl ${className}`}>
      <div className="px-6 py-3">
        <div className="flex items-center justify-between">
          <div className="text-white text-sm flex-1">
            {error}
          </div>
          <Button
            isIconOnly
            variant="light"
            size="sm"
            className="text-white hover:bg-white/10 ml-2"
            onPress={onClose}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorDisplay;
